<template>
  <div class="xmly-nav-right navbar">
      <ul class="nav-right">
          <li class="item">
              <a :href="`${PROTOCOL}${AVATAR_LINK}${uid}/`">
                  <div class="pic">
                      <img :src="avatar" alt="">
                  </div>
                  <p class="tit elli">{{name}}</p>
              </a>
          </li>
          <!--:类名new控制消息为新-->
          <!-- <li class="item">
              <a>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACzklEQVRYR9WW4VEUQRCFX0egRCBEIEYgRiBGgEQgRCBEoEYgRCBGAEYgRCBGIEbQ1rfVfTW3O7OzBz+unCrqrrjd7tevX78e05aPbTm//i8A7r4r6a2k95L2R+zdSrqQ9N3M7pcyu4gBd38u6VMkXhL7s6RzM3voPdwF4O5U+rWo+FLSlZldlcHd/VASf0fxfxg5NjM+m2cWQCS/lgQDdyTo0RttAtxLSTDwau6dJoCgneQwcGlm9F3ufhBVUi3A8pD0i5ndxHPoATZg4E2rHXMAziR9jMoPCODu9PZDp68AOY5nAAMT6IF4k1MFENX/iaeh8Nbds6K/kgBykdQG7TB0IulZVi2JqfkZcXZqLLQAEAzhMVKH7k5gpoDksFEVVmiGqgFBO07cHUYYXQRJEWunBYAgr/Mld0dMBKWXQ49bJzSCdjh7AI5ifpgZ3xcBwEheRABE+E1SNUANiLtnAaeS+E4b7s0MQPMAygrMzNw9xXhqZvS+e4p3BtDu7vESLUCQK6ectKCg+87M9otgXfoTWVFEAiin58HMdvLZGoABLdXzWQCoiqjRghTxqm0xKb/K2MP3cYCkqwCQwVZm1OtBwcC70rLHsRcBCBZyCvZ6VlwpiL4zhghw8JYsbhMAKcRZWx1pgCmCPUYP/8CUFgEYlI6JlNUUo4WC0cOaH7g74LDd8fkdSww3ncTuruOiKhYPAXLd0haS3pjZ+QgAmzN/m7hfiXATANBJ8qmbxcT0xFn7vQtgtJaJQT/xd1pBG5jryW4IRhhpJqF5RdvkQkIvz2oLpeEFqQlahYlVF1jvQoKHo156OtwJltIczOV9oDk9cwByjQ6WvDTxaHIQboKoGllrHZMwLxIbm88IBAwOFlxb5y0AuTwW2+8cQ8VVbrikdMfQ3fM+sOblj2lDWHkyOrkTtBjAPHZrN5gngBimYKynrg88NuHS97YO4B/DFm8w9wYLiQAAAABJRU5ErkJggg==">
                  <p class="tit elli">消息</p>
              </a>
          </li> -->
          <li class="item">
              <a  :href="`${PROTOCOL}${HOST}/doc/help/download`" target="_blank" download="城市合伙人系统使用手册.pdf">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACPElEQVRYR8WX7VEVQRBF741AjUCJAIlAjUCJQI1AMxAywAjECMQI1AiECMQIlAjaOtQMtT5mp2e2iqKr3g/evu050337A+uezfd8vjYDRMSJpJflAqe2j7dcZhNAOfzdzoHHto9mIbYC/JX0QNJBOfCnpEvbe3cOEBEPJf1ZOeiF7e8zENMRiIjnkr51DgHg0DZRSm0aAI8FgpBflr+fSHolCQ2QmnNJRCOFGAKICBzv2z7sXamkhwjsS/po+30WghQgIrjdLxzZnvq9pL0apTWQEYfUOyX32fab7EYlJaeSXo9EYQSAkD4rwjobBEAPXyT9sI1oV20EIMrbj0ZEVSJwU6pZ2oYBMke7V4yIa/DsvS7Asulkju4KoDadNJcNgKqdbnfMIoDqP0n6ahthDVtEIFim5VvbVEXTMoAhJy3PETEEvwqwbECShiugwoy+3wOg/X6YaUANHdQIru4KTYCiftov9Tw9YhdRqCJmKNGWbw2nNYDaSqfV36mG5nC6BbAz79NhkpXFjhYObDOqb6wFwA8Yp2fZ+M0OX6Si9oRz23WNu37cA+A5OSMdTML/yLPDI+JpmYiUI1rCLmzz/XoEeFJqmGWCSFRj++EmgPC5qlAlzI8l4ZwP4mOPqHYh6aTVkLJGhDNuQBfkgBn7TRqJYC966TRc5BEYQOgNPeMfFPQzlLJhgJagWFLK9ywfAE6X7RYAcsvt2H6XdkXeR5eW+uI0QBEpELTqOiHJ9VG2gLbytglgRonZb/8BTHX7IaSG5rQAAAAASUVORK5CYII=">
                  <p class="tit elli">帮助</p>
              </a>
          </li>
          <li class="item" @click="logout">
              <a>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABQklEQVRYR+WX/VECMRDF36tAqESpAOjEDrQDsQPtwE6ECsBOoILnPCbOHNxX7pLMoe5fmblL9pe3m82GmNg4sX/cHoCkGYAXAI8APE61I4APAK8kPb6wmgKS3gA8pXptmP9O8jkGwJR3ABYkD6kgkh4A7AEcSc5jAOSfSGbLD0mtazaF4E8CnENJ0uHoTcLsCnTlUbEQSNqGZF43Hb8fqNIASwCWvxWiJICLmFW474IoBmCJQ1XthCgKEAORBCDJ8bXEQ2xLcp0lCUcC7EiusgDEbDvkwScAF6EvAKvqsUwKQR9An/NzdbxepOvi6HNY/R7jvDSAj58LUU32KmhJBQzgYnQR8/9zGV3lg+uFSC4mUeDXdUSlmtITyVqbf5NtuSk34WHi9jzVTuFhsol6mKR6Gzo/W+8/1HHrbTh2obHzvgGJ3dkh/zGD/AAAAABJRU5ErkJggg==">
                  <p class="tit elli">退出</p>
              </a>
          </li>
      </ul>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
    }
  },
  created(){
  },
  computed:{
    ...mapGetters([
      'name',
      'avatar',
      'AVATAR_LINK',
      'PROTOCOL',
      'uid',
      'HOST'
    ])
  },
  methods: {
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload();// 为了重新实例化vue-router对象 避免bug
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar{
  position: absolute;
  left:0;
  top:0;
  right: 0;
  height:50px;
  width: 100%;
  background-color: #333;
}
.xmly-nav-right{
    overflow: hidden;
}
.xmly-nav-right .nav-right{
    overflow: hidden;
    padding:10px 0 0 0;
    background:#333;
    position: absolute;
    right: 0px;
}
.xmly-nav-right .nav-right .item{
    float: left;
    font-size: 12px;
    color: #fff;
    cursor: pointer;
    width:60px;
    text-align: center;
    position: relative;
}  
.xmly-nav-right .nav-right .item.new:after{
    content:'';
    display: inline-block;
    width:6px;
    height: 6px;
    background:#d53519;
    border-radius: 50%;
    position: absolute;
    top:1px;
    right:15px;
}  
.xmly-nav-right .nav-right .item a{
    display: block;
}
.xmly-nav-right .nav-right .item .pic{
    float: left;
    width:30px;
    height:30px;
    border-radius:2px;
}
.xmly-nav-right .nav-right .item .pic img{
    width:30px;
    height:30px;
    border-radius:2px;
}
.xmly-nav-right .nav-right .item .tit{color:#fff;}
.xmly-nav-right .nav-right .item:first-child{
    width:150px;
    line-height: 30px;
}
.xmly-nav-right .nav-right .item img{width:20px;height:20px;}
.elli{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;vertical-align: middle;}
</style>




// WEBPACK FOOTER //
// Navbar.vue?1f1a0564